import { render, staticRenderFns } from "./Itinerary.vue?vue&type=template&id=38d6d90a&"
import script from "./Itinerary.vue?vue&type=script&lang=js&"
export * from "./Itinerary.vue?vue&type=script&lang=js&"
import style0 from "./Itinerary.vue?vue&type=style&index=0&id=38d6d90a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports